module.exports = __webpack_public_path__ + "assets/valance-french-selected.38a9d4b0.svg";